import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, ShieldAlert } from "lucide-react";
import { Overline } from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ConfirmaCod() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setMessage("Link incomplet. Deschide linkul exact cum apare în email.");
      return;
    }
    axios
      .post(`${API}/staff-code/confirm`, { token })
      .then(({ data }) => {
        setState("ok");
        setMessage(data.message || "Noul cod de acces este activ.");
      })
      .catch((err) => {
        const detail = err.response?.data?.detail;
        setState("error");
        setMessage(
          typeof detail === "string"
            ? detail
            : "Confirmarea a eșuat. Cere din nou schimbarea codului din panou."
        );
      });
  }, [token]);

  return (
    <div className="mx-auto flex min-h-[70svh] max-w-xl items-center px-4 py-24">
      <div
        data-testid="confirm-code-card"
        className="w-full rounded-3xl border border-white/10 bg-surface p-8 sm:p-10"
      >
        <Overline>Cod de acces Staff</Overline>
        {state === "loading" && (
          <p
            data-testid="confirm-code-loading"
            className="mt-6 flex items-center gap-3 text-sm text-neutral-400"
          >
            <Loader2 className="h-4 w-4 animate-spin" /> Se confirmă schimbarea...
          </p>
        )}
        {state === "ok" && (
          <>
            <h1
              data-testid="confirm-code-success"
              className="mt-5 flex items-center gap-3 font-display text-2xl font-black uppercase tracking-tight text-white"
            >
              <CheckCircle2 className="h-6 w-6 text-neon" /> Cod activat
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-neutral-300">{message}</p>
          </>
        )}
        {state === "error" && (
          <>
            <h1
              data-testid="confirm-code-error"
              className="mt-5 flex items-center gap-3 font-display text-2xl font-black uppercase tracking-tight text-white"
            >
              <ShieldAlert className="h-6 w-6 text-flame" /> Nu am putut confirma
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-neutral-300">{message}</p>
          </>
        )}
        <Link
          to="/admin"
          data-testid="confirm-code-admin-link"
          className="mt-8 inline-flex rounded-full bg-neon px-7 py-3.5 font-display text-xs font-bold uppercase tracking-wider text-canvas transition-colors hover:bg-white"
        >
          Mergi la panoul Staff
        </Link>
      </div>
    </div>
  );
}
